var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.inMaintenance)?_c('Maintenance',{attrs:{"date":_vm.maintenanceEndDate,"button-text":"Try again"},on:{"leaveButtonClick":function($event){return _vm.$store.dispatch('maintenance/hide')}}}):_c('div',[(_vm.showSiteWideAlert)?_c('site-wide-alert'):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }